import { observer } from "mobx-react";
import React from "react";
export const TopNavRightElement = observer((props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "navbar-right-element" }, props.children)));
});
export default TopNavRightElement;
